/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconLightBulb: {
  name: 'light_bulb';
  data: string;
} = {
  name: 'light_bulb',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="M481.054 196.352c0-102.452-83.034-185.225-185.812-185.225-102.775.001-186.746 82.774-186.746 185.225 0 114.484 83.102 116.561 83.102 261.548h.21v88.94h47.47v24.561h113.09V546.84h45.376V457.9h.208c0-146.915 83.102-149.363 83.102-261.548zm-229.21 60.495 44.677-48.866 43.98 46.773 55.847-46.773-42.875 160.01-114.195.266-42.946-160.276 55.512 48.866z"/></svg>`,
};
